class ScrollSpy {

    static instance;

    constructor(anchors, offset = 0) {
        this._anchors        = anchors;
        this._anchorsIndex   = 0;
        this._currentAnchor  = null;
        this._currentSection = null;
        this._offset         = offset;
        this._listeners      = [];
        this._onChange       = () => {
        };

        let scrollPosition = window.screenY || window.pageYOffset;

        // Set the current index
        for (let i = 0; i < this._anchors.length; i++) {
            let attribute = this._anchors[i].hasAttribute('href') ? 'href' : 'data-target';
            if (this._scrollIsInElement(scrollPosition, document.querySelector(this._anchors[i].getAttribute(attribute)))) {
                this._anchorsIndex = i;
                break;
            }
        }

        this._setCurrentElement();

        this._createListener();
    }

    _createListener() {
        let prevScroll     = 0;
        let scrollPosition = window.scrollY || window.pageYOffset;

        let attribute       = this._currentAnchor.hasAttribute('href') ? 'href' : 'data-target';
        let firstSection    = document.querySelector(this._anchors[0].getAttribute(attribute));
        let topFirstSection = this._topSection(scrollPosition, firstSection);

        window.addEventListener('scroll', () => {
            scrollPosition = window.scrollY || window.pageYOffset;

            if (!this._scrollIsInElement(scrollPosition) && scrollPosition >= topFirstSection) {

                // Scroll to the bottom
                if (prevScroll < scrollPosition) {
                    // There are at least one more anchor
                    if (this._anchorsIndex < this._anchors.length - 1) {
                        this._anchorsIndex++;
                    }
                } else {
                    //Scroll to the top
                    // This is not the first anchor
                    if (this._anchorsIndex > 0) {
                        this._anchorsIndex--;
                    }
                }

                this._onChange();

            } else if (scrollPosition < topFirstSection) {
                this._anchors[0].classList.remove('active');
            }

            this._setCurrentElement();

            for (let listener of this._listeners) {
                listener();
            }

            prevScroll = scrollPosition;
        });
    }

    addListener(listener = () => {
    }) {
        this._listeners.push(listener);
    }

    onChange(listener = () => {
    }) {
        this._onChange = listener;
    }

    _setCurrentSection() {
        let attribute        = this._currentAnchor.hasAttribute('href') ? 'href' : 'data-target';
        this._currentSection = document.querySelector(this._currentAnchor.getAttribute(attribute));
    }

    /**
     * Activate an anchor
     *
     * @private
     */
    _setCurrentAnchor() {

        // Remove previous active anchor
        for (let anchor of this._anchors) {
            let parentMenu = anchor.parentElement.parentElement.previousElementSibling;

            if (parentMenu !== null && parentMenu.tagName === 'SPAN') {
                parentMenu.classList.remove('active');
            } else {
                anchor.classList.remove('active');
            }
        }

        let scrollPosition = window.scrollY || window.pageYOffset;
        if (this._scrollIsInElement(scrollPosition)) {
            let parentMenu = this._currentAnchor.parentElement.parentElement.previousElementSibling;

            if (parentMenu !== null && parentMenu.tagName === 'SPAN') {
                parentMenu.classList.add('active');
            } else {
                this._currentAnchor.classList.add('active');
            }
        }
    }

    _setCurrentElement() {
        this._currentAnchor = this._anchors[this._anchorsIndex];
        this._setCurrentSection();
        this._setCurrentAnchor();
    }

    /**
     * @param scrollPosition
     * @param element
     * @return {boolean}
     * @private
     */
    _scrollIsInElement(scrollPosition, element = this._currentSection) {
        let sectionRect   = element.getBoundingClientRect();
        let sectionTop    = this._topSection(scrollPosition, element);
        let sectionBottom = sectionTop + sectionRect.height;

        if (this._anchorsIndex === this._anchors.length - 1) {
            sectionBottom = document.body.offsetHeight;
        }

        return scrollPosition >= sectionTop - 120 && scrollPosition < sectionBottom;
    }

    _topSection(scrollPosition, element) {
        let sectionRect = element.getBoundingClientRect();

        return scrollPosition + sectionRect.top - this._offset;
    }

    getAnchorsIndex() {
        return this._anchorsIndex;
    }

    getOffset() {
        return this._offset;
    }

    getCurrentSection() {
        return this._currentSection;
    }
}

module.exports = ScrollSpy;